import React from 'react';
import { CheckCircle2, Target, Users, Lightbulb, TrendingUp } from 'lucide-react';
import { aboutData } from '../data/mock';

const About = () => {
  const features = [
    { icon: Target, title: 'Strategic Vision', description: 'Shaping impactful strategies within the IT consulting industry' },
    { icon: Users, title: 'People Development', description: 'Coaching high potentials and developing future leaders' },
    { icon: Lightbulb, title: 'Innovation Focus', description: 'Championing innovation to ensure unparalleled client outcomes' },
    { icon: TrendingUp, title: 'Business Growth', description: 'Driving sustainable growth through operational excellence' }
  ];

  return (
    <section id="about" className="py-24 bg-[#f3ede0]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-gold-400/10 text-gold-400 text-sm font-semibold rounded-full mb-4">
            About Me
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#152846] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Transforming Organizations Through
            <span className="text-gold-400"> Human Capital Excellence</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <p className="text-lg text-[#5c6878] leading-relaxed mb-8">
              {aboutData.summary}
            </p>
            <div className="space-y-4">
              {aboutData.highlights.map((highlight, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-gold-400 mt-0.5 flex-shrink-0" strokeWidth={2.5} />
                  <span className="text-[#3e4858] font-medium">{highlight}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group p-6 bg-[#fffdf8] rounded-2xl border border-[#e6dfd0] hover:bg-gold-400 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
                data-testid={`about-feature-${index}`}
              >
                <div className="w-12 h-12 bg-gold-400/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-black/20 transition-colors">
                  <feature.icon className="w-6 h-6 text-gold-400 group-hover:text-black transition-colors" strokeWidth={2.5} />
                </div>
                <h3 className="text-lg font-semibold text-[#152846] mb-2 group-hover:text-black transition-colors">
                  {feature.title}
                </h3>
                <p className="text-sm text-[#8b94a3] group-hover:text-black/70 transition-colors">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
